import request from "../Config/axios";
// -----------------------------------------------------------
export const GetById_Period_Api = async (id) => {
    const { data } = await request.get(
        `/Period/GetById/?id=${id}`
    );
    return data;
};
// -----------------------------------------------------------
export const GetAll_Period_Api = async () => {
    const { data } = await request.post(
        `/Period/GetAll`
    );
    return data;
};
// -----------------------------------------------------------
export const GetAll_Active_Now_Period_Api = async () => {
    const { data } = await request.get(
        `/Period/GetAll_Active_Now`
    );
    return data;
};
// -----------------------------------------------------------
export const Update_Period_Api = async (params) => {
    const { data } = await request.post(
        `/Period/Update`,
        params
    );
    return data;
};
// -----------------------------------------------------------
export const Add_Period_Api = async (params) => {
    const { data } = await request.post(
        `/Period/Add`,
        params
    );
    return data;
};
// -----------------------------------------------------------
export const GetAll_Paging_Period_Api = async (params) => {
    const { data } = await request.post(
        `/Period/GetAll_Paging`,
        params
    );
    return data;
};
// -----------------------------------------------------------
export const Delete_Period_Api = async (id) => {
    const { data } = await request.delete(
        `/Period/Delete/?id=` + id,
    );
    return data;
};
// -----------------------------------------------------------
export const GetAllReserves_Period_Api = async (periodId) => {
    const { data } = await request.get(
        `/Period/GetAllReserves/?periodId=${periodId}`
    );
    return data;
};
// -----------------------------------------------------------
export const DoLottery_Period_Api = async (periodId) => {
    const { data } = await request.get(
        `/Period/DoLottery/?periodId=${periodId}`
    );
    return data;
};
// -----------------------------------------------------------
export const ConfimLottery_Period_Api = async (periodId) => {
    const { data } = await request.get(
        `/Period/ConfimLottery/?periodId=${periodId}`
    );
    return data;
};
// -----------------------------------------------------------
export const GetAllWons_Period_Api = async (periodId) => {
    const { data } = await request.get(
        `/Period/GetAllWons/?periodId=${periodId}`
    );
    return data;
};
// -----------------------------------------------------------